// CURRENT CART

/** @return {object} -get current user*/
const getCurrentUserInfo = state => {
  return state.currentUser;
};
/** @return {object} -get current user*/
const getCurrentUserShippingInfo = state => {
  return state.currentUserShippingAddress;
};

/** @return {object} -get current user billing address*/
const getCurrentUserBillingAddress = state => {
  return state.currentUserBillingAddress;
};

/** @return {object} -get current user*/
const isCurrentUserIsLoggedIn = state => {
  return state.currentUser.isLoggedIn;
};

export default {
  isCurrentUserIsLoggedIn,
  getCurrentUserInfo,
  getCurrentUserShippingInfo,
  getCurrentUserBillingAddress
};
